<template>
    <div id="services" class="home-services">
        <h2 class="home-services__title">Testaankoop, tot je dienst</h2>
        <!--<div class="home-service-content">-->
        <!--    <div class="service" v-for="(service, serviceKey) in services" :key="serviceKey">-->
        <!--        <img :src="service.img" :alt="service.altimg"-->
        <!--             data-aos="fade-up" :data-aos-delay="200*(serviceKey+1)" data-aos-once="true">-->
        <!--        <h3 class="service-title" v-html="service.title"></h3>-->
        <!--        <p class="service-text" v-html="service.text"></p>-->
        <!--    </div>-->
        <!--</div>-->
        <div class="home-service-carousel">
            <hooper :settings="settings" @slide="updateCarousel" ref="servicecarousel">
                <slide v-for="(service, serviceKey) in services" :key="serviceKey">
                    <img :src="service.img" :alt="service.altimg"
                         data-aos="fade-up" :data-aos-delay="200*(serviceKey+1)" data-aos-once="true">
                    <h3 class="service-title" v-html="service.title"></h3>
                    <p class="service-text" v-html="service.text"></p>
                </slide>
                <pagination slot="hooper-addons" mode="fraction"></pagination>
                <navigation slot="hooper-addons">
                    <template #hooper-prev>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44">
                            <g fill="none" fill-rule="evenodd" stroke="#FF8600" transform="translate(1 1)">
                                <path fill="#FF8600" fill-rule="nonzero" stroke-width=".5"
                                      d="M17.7 14.2c.3-.3.8-.3 1 0 .4.3.4.8 0 1l-5.2 5.3h17.4c.4 0 .8.3.8.7 0 .4-.4.7-.8.7H13.5l5.3 5.3c.3.3.3.7 0 1-.3.3-.8.3-1 0l-6.6-6.5a.7.7 0 010-1l6.5-6.5z"/>
                                <circle cx="21" cy="21" r="21"/>
                            </g>
                        </svg>
                    </template>
                    <template #hooper-next>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44">
                            <g fill="none" fill-rule="evenodd" stroke="#FF8600" transform="matrix(-1 0 0 1 43 1)">
                                <path fill="#FF8600" fill-rule="nonzero" stroke-width=".5"
                                      d="M17.7 14.2c.3-.3.8-.3 1 0 .4.3.4.8 0 1l-5.2 5.3h17.4c.4 0 .8.3.8.7 0 .4-.4.7-.8.7H13.5l5.3 5.3c.3.3.3.7 0 1-.3.3-.8.3-1 0l-6.6-6.5a.7.7 0 010-1l6.5-6.5z"/>
                                <circle cx="21" cy="21" r="21"/>
                            </g>
                        </svg>
                    </template>
                </navigation>
            </hooper>
        </div>
        <ScrollLink link="#trusts" styleType="squared" arrow="orange">Vertrouw op Testaankoop</ScrollLink>
    </div>
</template>

<script>
import {Hooper, Slide, Pagination, Navigation} from 'hooper';
import 'hooper/dist/hooper.css';
import ScrollLink from "../ScrollLink";

export default {
    name: "HomeService",
    components: {
        Hooper, Slide, Pagination, Navigation, ScrollLink
    },
    data() {
        return {
            services: [
                {
                    img: '/images/nl_multigift/service1.jpg',
                    altimg: '',
                    title: 'Juridische advies: <br> 80% van de geschillen opgelost ',
                    text: 'Een conflict met een bedrijf? Dien een klacht in via ons platform. De handtekening van Testaankoop geeft je klacht meer gewicht en versnelt de reactie van het merk met gemiddeld 4 dagen. En als dat niet volstaat, staan er vijftig advocaten klaar om je te helpen je rechten te doen gelden. '
                },
                {
                    img: '/images/nl_multigift/service2.jpg',
                    altimg: '',
                    title: 'Bespaar € 1254 per jaar',
                    text: 'Dat bedrag besparen onze leden gemiddeld dankzij onze koopwijzers, groepsaankopen en exclusieve kortingen … En daarvoor hoeven ze helemaal niets te laten! Ze passen gewoon de juiste tips en adviezen toe om onnodige kosten te vermijden.'
                },
                {
                    img: '/images/nl_multigift/service3.jpg',
                    altimg: '',
                    title: 'Veilige en persoonlijke keuzes.',
                    text: 'Van energieleverancier veranderen, een wasmachine kopen of je ziekenfonds kiezen? Onze koopwijzers leiden je naar het product dat het beste aansluit bij jouw prioriteiten. Een specifieke vraag over isolatie, energiepremies, antivirusprogramma’s, je belastingaangifte? Bel ons! Onze specialisten geven je persoonlijk antwoord.'
                },
                {
                    img: '/images/nl_multigift/service4.jpg',
                    altimg: '',
                    title: 'De nieuwste consumptietrends.',
                    text: 'Elke dag ontleden onze experts de actualiteit rond juridische en consumententhema’s: beknopte info die je altijd bij de hand hebt dankzij onze papieren en digitale magazines en onze website. Inclusief tips om oplichting te voorkomen! In onze catalogus met gidsen ontdek je thema’s die we tot op het bot behandelen: verzekeringen, allergieën, de cloud ... Verdiep je in de onderwerpen die jou interesseren, wanneer je maar wilt.'
                },
                {
                    img: '/images/nl_multigift/service5.jpg',
                    altimg: '',
                    title: 'Elk jaar overwinningen voor de consument',
                    text: 'Meer dan duizend consumenten schadeloosgesteld, groen licht voor de Nutriscore, het einde van de roamingkosten in de landen van de Europese gemeenschap, een vermindering van de CO2-uitstoot met 20% tegen 2025 en met 40% tegen 2030 behaald in het Europees Parlement dankzij intensief lobbywerk samen met de European Consumer Organisation … Door Testaankoop te steunen maak jij al deze overwinningen mee mogelijk.'
                },
                {
                    img: '/images/nl_multigift/service6.jpg',
                    altimg: '',
                    title: 'Gezondheid en voeding onder de loep van Testaankoop Gezond.',
                    text: 'Is jouw ziekenfonds nog wel aangepast aan je huidige situatie? Kijk het na met onze ziekenfondsvergelijker. Twijfels over een geneesmiddel? Onze geneesmiddelendatabank geeft je informatie over de indicatie, doeltreffendheid en eventuele alternatieven. Testaankoop Gezond is een concrete hulp voor je dagelijkse gezondheid. '
                },
                {
                    img: '/images/nl_multigift/service7.jpg',
                    altimg: '',
                    title: 'Van leverancier veranderen? <br>Wij regelen alles.',
                    text: 'Zou je graag van energieleverancier of telefoonprovider willen veranderen zonder rompslomp? Meld het ons online of telefonisch. Testaankoop regelt het voor je. Voor een vrij gevoel!'
                },
                {
                    img: '/images/nl_multigift/service8.jpg',
                    altimg: '',
                    title: 'Maak je autobudget lichter dankzij exclusieve kortingen.',
                    text: 'Bespaar aan de pomp en de laadpaal dankzij de Testaankoop-tankkaart. Kortingen zijn geldig bij 850 tankstations en elektrische laadpunten. Maak ook slimmere keuzes voor een autoverzekering of banden dankzij onze vergelijkende tests.'
                },
            ],
            settings: {
                infiniteScroll: true,
                wheelControl: false,
                breakpoints: {
                    1000: {
                        itemsToShow: 2,
                    }
                }
            }
        }
    },
    methods: {
        slidePrev() {
            this.$refs.servicecarousel.slidePrev();
        },
        slideNext() {
            this.$refs.servicecarousel.slideNext();
        },
        updateCarousel(payload) {
            this.myCarouselData = payload.currentSlide;
        }
    },
}
</script>

<style scoped>

</style>
